<template>
  <div class="c17 doc-content">
    <p class="c2"><span class="c5">TERMS AND CONDITIONS</span></p>
    <p class="c3"><span class="c1">Effective from: 16 January 2026</span></p>
    <p class="c0"><span class="c1">These Terms and Conditions ("Agreement" or "Terms") is an agreement between you and Techss Limited (hereinafter "Techss") and applies to your use of the website at https://techss.co/ (referred to herein below as the "website").</span></p>
    <p class="c0"><span class="c1">Please read carefully, agree and accept all the terms and conditions contained in this Agreement and the Privacy Policy contained on the website, which are an integral part of this Agreement, before you use the services provided by Techss.</span></p>
    <p class="c0"><span class="c1">These Terms apply in full force and effect to your use of this website and by using this website, you expressly accept all terms and conditions contained herein in full. You must not use this website, if you have any objection to any of these Terms.</span></p>
    <p class="c0"><span class="c1">You understand and agree that your access to and use of the website is entirely at your own discretion and risk, and that you will be solely responsible for any loss or damage that may arise from such access and use.</span></p>
    <p class="c0"><span class="c1">Please note that any actions on the website that are made by using your Internet connection or electronic device, unless you prove otherwise, shall be deemed as have been taken by you.</span></p>
    <p class="c0"><span class="c1">The following definitions will apply here: "you" or "your" means any natural person or entity using the website ("Client"), unless otherwise stated herein. "Techss", "we", "our", "Company" or "Partners" together will refer to Techss and its subsidiaries, Partners, unless otherwise stated.</span></p>
    
    <p class="c0"><span class="c5">Information about us</span></p>
    <p class="c0"><span class="c1">This website is owned and maintained by Techss Limited, a company incorporated under the laws of Seychelles, with the registered office at: 306, Victoria House, Victoria, Mahe, Seychelles, registration number 242334.</span></p>
    
    <p class="c0"><span class="c5">Conditions of Use</span></p>
    <p class="c0"><span class="c1">You are specifically restricted from using this website in any way that is or may be damaging to this website, using this website contrary to applicable laws and regulations, or in any way may cause harm to the website, or to any person or business entity.</span></p>
    <p class="c0"><span class="c1">You may use the Website only for lawful purposes and in accordance with these Terms. You agree not to use the Website:</span></p>
    <ul class="c7 lst-kix_list_3-0 start">
      <li class="c11 li-bullet-0"><span class="c1">In any way that violates any applicable federal, state, local or international law or regulation;</span></li>
      <li class="c11 li-bullet-0"><span class="c1">In any manner that involves transmitting or sending of, any advertising or promotional material, including any "junk mail", "chain letter" or "spam" or any other similar solicitation;</span></li>
      <li class="c11 li-bullet-0"><span class="c1">In any manner that involves impersonating or attempt to impersonate the Company, a Company's employee, another user or any other person or entity (including, without limitation, by using e-mail addresses associated with any of the foregoing);</span></li>
      <li class="c11 li-bullet-0"><span class="c1">In any manner that involves engaging in any other conduct that restricts or inhibits anyone's use or enjoyment of the Website or our digital assets, or which, as determined by us, may harm the Company or users of the Website or expose them to liability;</span></li>
      <li class="c11 li-bullet-0"><span class="c1">In the manner that is or may be considered as defamatory, harassing, pornographic, embarrassing, vulgar, malicious, harmful, threatening, indecent, derogatory, discriminatory, untrue, political, abusive, sexist, hateful, offensive, menacing, obscene, racist, profane.</span></li>
    </ul>
    <p class="c0"><span class="c1">In addition, you agree not to:</span></p>
    <ul class="c7 lst-kix_list_3-0">
      <li class="c11 li-bullet-0"><span class="c1">Use any robot, spider or another automatic device, process or means to access the Website for any purpose, including monitoring or copying any of the material on the Website;</span></li>
      <li class="c11 li-bullet-0"><span class="c1">Use any manual process to monitor or copy any of the material on the Website or for any other unauthorized purpose without our prior written consent;</span></li>
      <li class="c11 li-bullet-0"><span class="c1">Use the Website in any manner that could disable, overburden, damage, or impair the site or interfere with any other party's use of the Website, including their ability to engage in real time activities through the Website;</span></li>
      <li class="c11 li-bullet-0"><span class="c1">Use any device, software or routine that interferes with the proper working of the Website;</span></li>
      <li class="c11 li-bullet-0"><span class="c1">Introduce any viruses, trojan horses, worms, logic bombs or other material which is malicious or technologically harmful;</span></li>
      <li class="c11 li-bullet-0"><span class="c1">Attempt to gain unauthorized access to, interfere with, damage or disrupt any parts of the Website, the server on which the Website is stored, or any server, computer or database connected to the Website;</span></li>
      <li class="c11 li-bullet-0"><span class="c1">Attack the Website via a denial-of-service attack or a distributed denial-of-service attack;</span></li>
      <li class="c11 li-bullet-0"><span class="c1">Otherwise attempt to interfere with the proper working of the Website.</span></li>
    </ul>
    
    <p class="c0"><span class="c5">Intellectual Property</span></p>
    <p class="c0"><span class="c1">Techss own all rights to the intellectual property and material contained in this website, and all such rights are reserved. You are granted a limited license only, subject to the restrictions provided in these Terms, for purposes of viewing the material contained on this website. You must not republish material from this website (including republication on another website), or reproduce or store material from this website in any public or private electronic retrieval system; you must not reproduce, duplicate, copy, sell, re-sell, visit, or otherwise exploit our website or material on our website for a commercial purpose, without our express written consent. Elements of the website are protected by trade dress, trade secret and other laws and may not be copied or imitated in whole or in part. All custom graphics, icons, and other items that appear on the website are trademarks, service marks or trade dress of Techss and may not be used or interfered with in any manner without the express written consent of Techss. In consideration of this, users agree that copies of the information will retain all copyright and other proprietary notices.</span></p>
    
    <p class="c0"><span class="c5">Legal terms</span></p>
    <p class="c0"><span class="c1">This website may contain other proprietary notices and copyright information, the terms of which must be observed and followed. Information on this website may contain typographical errors or technical inaccuracies. Information may be changed or updated without notice.</span></p>
    
    <p class="c0"><span class="c5">Indemnification and Limitation of liability</span></p>
    <p class="c0"><span class="c1">You hereby indemnify to the fullest extent Techss from and against any and/or all liabilities, costs, demands, causes of action, damages and expenses arising in any way related to your breach of any of the provisions of these Terms.</span></p>
    <p class="c0"><span class="c1">IN NO EVENT WILL TECHSS BE LIABLE TO ANY PARTY FOR ANY DIRECT, INDIRECT, SPECIAL OR OTHER CONSEQUENTIAL DAMAGES FOR ANY USE OF THIS WEBSITE, OR ON ANY OTHER HYPER LINKED WEBSITE, INCLUDING, WITHOUT LIMITATION, ANY LOST PROFITS, BUSINESS INTERRUPTION, LOSS OF PROGRAMS OR OTHER DATA ON YOUR INFORMATION HANDLING SYSTEM OR OTHERWISE, EVEN IF WE ARE EXPRESSLY ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. TECHSS IS NOT RESPONSIBLE FOR CONTENT OF THIRD-PARTIES WEBSITES.</span></p>
    
    <p class="c0"><span class="c5">Modifications</span></p>
    <p class="c0"><span class="c1">We can revise and update these Terms at any time without notice. In case of any changes, amendments, modifications, or corrections, we will post the revised version of the Terms on the website. It is your responsibility to check these Terms for any changes whenever you access the website. Your continued usage of the website after any changes to these Terms of Use will mean you accept those changes</span></p>
    
    <p class="c0"><span class="c5">Contact us</span></p>
    <p class="c0"><span class="c1">Any questions, comments and requests regarding these Terms should be addressed by writing to us by sending an e-mail to: </span><span class="c14"><a class="c15" href="mailto:info@techss.co">info@techss.co</a></span></p>
  </div>
</template>

<script setup>

</script>

<style lang="stylus" scoped>

ul.lst-kix_list_3-0 {
  list-style-type: none
}

.lst-kix_list_3-0 > li:before {
  content: "\0025cf   "
}

li.li-bullet-0:before {
  margin-left: -17.9pt;
  white-space: nowrap;
  display: inline-block;
  min-width: 17.9pt
}

ol {
  margin: 0;
  padding: 0
}

table td, table th {
  padding: 0
}

.c11 {
  margin-left: 35.9pt;
  padding-top: 0pt;
  padding-left: -0.1pt;
  padding-bottom: 6pt;
  line-height: 1.0791666666666666;
  orphans: 2;
  widows: 2;
  text-align: justify
}

.c1 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: 'Inter', sans-serif;
  font-style: normal
}

.c5 {
  color: #000000;
  font-weight: 700;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: 'Inter', sans-serif;
  font-style: normal
}

.c2 {
  padding-top: 0pt;
  padding-bottom: 12pt;
  line-height: 1.5;
  orphans: 2;
  widows: 2;
  text-align: center
}

.c3 {
  padding-top: 0pt;
  padding-bottom: 8pt;
  line-height: 1.5;
  orphans: 2;
  widows: 2;
  text-align: left
}

.c0 {
  padding-top: 0pt;
  padding-bottom: 8pt;
  line-height: 1.0791666666666666;
  orphans: 2;
  widows: 2;
  text-align: justify
}

.c14 {
  text-decoration-skip-ink: none;
  -webkit-text-decoration-skip: none;
  color: #0563c1;
  text-decoration: underline
}

.c17 {
  background-color: #ffffff;
  max-width: 960rem;
  position relative;
  left 50%;
  transform translate(-50%);
  margin-top: 30rem;
}

.c15 {
  color: inherit;
  text-decoration: inherit
}

.c7 {
  padding: 0;
  margin: 0
}

li {
  color: #000000;
  font-size: 11pt;
  font-family: 'Inter', sans-serif;
}

p {
  margin: 0;
  color: #000000;
  font-size: 11pt;
  font-family: 'Inter', sans-serif;
}

a {
  color #00c853!important
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
}

@media (max-width: 960px) {
  .c17 {
    width 90%
    left 5%
    transform none
    padding 0
  }
}

</style>
